module.exports = __webpack_public_path__ + "img/shuzi.a8159d0a.webp";